import React, { useContext } from 'react'
import './TaskActionPopeye.css'
import ClickItem from '../widgets/ClickItem'
import { ItemType, LifeCycle, Priority, Progress, TodoContext } from './Project'

export default function TaskActionPopeye({id, pos, visible = false, setVisible, aRef}) {

  const {tasks, setTasks, updateTask, setPopeyeOn} = useContext(TodoContext);
  const task = tasks.filter(task => task.id === id)[0];
  
  const toDone = () => {    
    task.progress = Progress.Done;
    updateTask(task);    
    setPopeyeOn(false);
  }

  const toInProgress = () => {
    task.progress = Progress.InProgress;
    task.priority = Priority.Now;
    updateTask(task);
    setPopeyeOn(false);
  }

  const toNow = () => {
    task.progress = Progress.Pending;
    task.priority = Priority.Now;
    updateTask(task);
    setPopeyeOn(false);
  }

  const toBacklog = () => {
    task.progress = Progress.Pending;
    task.priority = Priority.Backlog;
    updateTask(task);
    setPopeyeOn(false);
  }

  const toLab = () => {
    task.progress = Progress.Pending;
    task.priority = Priority.None;    
    task.lifeCycle = LifeCycle.Lab;
    updateTask(task);    
    setPopeyeOn(false);
  }

  const toResource = () => {
    task.progress = Progress.Pending;
    task.priority = Priority.None;
    task.ItemType = ItemType.Resource;
    updateTask(task);    
    setPopeyeOn(false);
  }

  const toComingUpNext = () => {
    task.progress = Progress.Pending;
    task.priority = Priority.ComingUpNext;
    updateTask(task);
    setPopeyeOn(false);
  }

  const deleteTask = () => {
    const tasksWithSelectedRemoved = tasks.filter(task => task.id !== id)
    setTasks(tasksWithSelectedRemoved);
    setPopeyeOn(false);
  }
  
  const handleControlClick = () => {
    setVisible(false);
  }

  if (!visible) {    
    return '';  
  }

  return (<div className='popeye' ref={aRef}>
      <div className='popeyeControlBar' style={{position: 'fixed', left: (pos.x - 148), top: (pos.y - 210)}}> 
        <button className='popButton' style={{color: '#aa1111', fontWeight: 'bold'}} onClick={handleControlClick}>X</button>
        <button className='popButton' style={{color: '#11aa11', fontWeight: 'bold'}} onClick={handleControlClick}>OK</button>
      </div>
      <div tabIndex='0' style={{position: 'fixed', left: (pos.x - 100), top: (pos.y - 210)}} className='taskActionPopeye'>
        <ClickItem onClick={toDone} style={{color: 'green'}}>Set to Done</ClickItem>
        <ClickItem onClick={toInProgress} style={{color: 'orange'}}>In Progress</ClickItem>
        <ClickItem onClick={toNow}>Todo Now</ClickItem>
        <ClickItem onClick={toBacklog}>Backlog</ClickItem>
        <ClickItem onClick={toComingUpNext}>Coming Up Next</ClickItem>
        <ClickItem onClick={toLab}>Lab</ClickItem>
        <ClickItem onClick={deleteTask} style={{color: 'red'}}>Delete</ClickItem>
      </div>    
    </div>)  
}
